import React, { useState } from 'react';
import TopBar from './components/TopBar';
import WishForm from './components/WishForm';
import Confirmation from './components/Confirmation';
import ErrorScreen from './components/ErrorScreen';
import LampIcon from './components/LampIcon';
import Footer from './components/Footer';
import './App.css';

// View states
const VIEW = { FORM: 'form', CONFIRM: 'confirm', ERROR: 'error' };

export default function App() {
  const [view, setView] = useState(VIEW.FORM);
  const [submitterName, setSubmitterName] = useState('');

  function handleSuccess(fields) {
    setSubmitterName(fields.name);
    setView(VIEW.CONFIRM);
  }

  function handleError() {
    setView(VIEW.ERROR);
  }

  function handleRetry() {
    setView(VIEW.FORM);
  }

  return (
    <div className="app">
      {/* Ambient glow */}
      <div className="app__glow app__glow--top" />
      <div className="app__glow app__glow--bottom" />

      <div className="app__container">
        <TopBar />

        {view === VIEW.FORM && (
          <main className="app__main app__main--form">
            {/* Hero heading */}
            <div className="app__hero">
              <div className="app__lamp-wrap">
                <LampIcon size={36} />
              </div>
              <h1 className="app__headline">
                Make a<br />
                <em>procurement wish.</em>
              </h1>
              <p className="app__lede">
                Tell us the one process driving your team crazy.
                A week from now, we'll send you a custom one-page sketch
                of the AI agent we'd build for it.
              </p>
            </div>

            {/* Ornamental divider */}
            <div className="app__divider">
              <span className="app__divider-line" />
              <span className="app__divider-dot" />
              <span className="app__divider-line" />
            </div>

            <WishForm onSuccess={handleSuccess} onError={handleError} />
          </main>
        )}

        {view === VIEW.CONFIRM && (
          <main className="app__main">
            <Confirmation submitterName={submitterName} />
          </main>
        )}

        {view === VIEW.ERROR && (
          <main className="app__main">
            <ErrorScreen onRetry={handleRetry} />
          </main>
        )}

        <Footer />
      </div>
    </div>
  );
}
